import React, { useState } from 'react'
import LeftPanel from '../components/LeftPanel'
import RightSide from '../components/RightSide'

const OrdersPage = () => {

  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  const [isOrdersTablePopUpOpen, setIsOrdersTablePopUpOpen] = useState(false);
  const [isDailyReportSummary, setIsDailyReportSummary] = useState(false);

  sessionStorage.setItem('selected-page', '/orders');

  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
        setIsDailyReportSummary={setIsDailyReportSummary}
        isDailyReportSummary={isDailyReportSummary}
      />
      <RightSide
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
        isOrdersTablePopUpOpen={isOrdersTablePopUpOpen}
        setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
        setIsDailyReportSummary={setIsDailyReportSummary}
        isDailyReportSummary={isDailyReportSummary}
      />
    </>
  );
};

export default OrdersPage;
